import { Component } from '@angular/core';
import { NavigationService } from 'app/core/services/navigation.service';

@Component({
  selector: 'slide-settings-navigation',
  templateUrl: 'slide-settings-navigation.component.html',
  styleUrls: []
})

export class SlideSettingsNavigationComponent {
  public menuItems: Array<INavItem>;
  private _paths = {
    AccountInformation: 'account-information',
    ChangeAutoLoginAdministrator: 'change-administrator'
  }

  constructor(private _navigationService: NavigationService) {

  }

  ngOnInit() {
    this._navigationService.settingsMenuNavItems.subscribe(navItems => {
      this.menuItems = navItems;
    });
  }

  public getPath(name: string) {
    return this._paths[name];
  }
}
